import { IntlMessageKeys } from 'features/i18n/IntlMessageKeys';

const loginErrorMessages: Record<string, IntlMessageKeys> = {
  ERROR_CUSTOMER_DISABLED: 'login.error.account_deactivated',
  ERROR_GENERAL: 'login.login_failed'
} as const;

type LoginErrorName = keyof typeof loginErrorMessages;

export const getLoginErrorTranslation = (errorCode?: LoginErrorName): IntlMessageKeys => {
  return errorCode
    ? loginErrorMessages[errorCode] || loginErrorMessages.ERROR_GENERAL
    : loginErrorMessages.ERROR_GENERAL;
};
